<template>
<div :loading="status" class="ofH">
	<div class="loading">
		<div class="tableSys h100pct vaM_E">
			<div>
				<div class="effect">
					<div></div>
					<div></div>
					<div></div>
				</div>
				<div v-if="loadingText" class="mt2x cSub">{{loadingText}}</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
import {loadingChange} from "@/util/lib.js";
export default {
	name: 'loading',
	components: {},
	props: {
		text: {
			type: String,
			required: false,
			default: ''
		},
		status:{
			type:[String],
			default:"true"
		},
		// id:{
		// 	type:String,
		// 	default:"loading"+Math.round(Math.random()*99999)
		// }
	},
	data(){
		return {
			// id:"loading"+Math.round(Math.random()*99999)
		}
	},
	watch:{
		status:function(val){
			if(val=="true") this.show();
			else this.hide();
		}
	},
	computed: {
		loadingText() {
			return this.text
		}
	},
	methods:{
		show:function(){
			loadingChange($(this.$el),"true");
		},
		hide:function(){
			loadingChange($(this.$el),"false");
		}
	}
}
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/common/ui/Loading.vue